<template
  ><div class="gm-code">
    <div ref="lines" class="gm-code-lines" aria-hidden="true">{{ lines }}</div>
    <textarea
      ref="input"
      :value="value"
      aria-label="Email HTML source"
      spellcheck="false"
      @input="$emit('input', $event.target.value)"
      @scroll="$refs.lines.scrollTop = $event.target.scrollTop"
      @keydown.tab.prevent="indent"
    /></div
></template>
<script>
export default {
  props: { value: { type: String, default: '' } },
  computed: {
    lines() {
      return this.value
        .split('\n')
        .map((_, index) => index + 1)
        .join('\n');
    }
  },
  methods: {
    indent() {
      const input = this.$refs.input;
      const start = input.selectionStart;
      this.$emit(
        'input',
        this.value.slice(0, start) + '  ' + this.value.slice(input.selectionEnd)
      );
      this.$nextTick(() => {
        input.selectionStart = input.selectionEnd = start + 2;
      });
    }
  }
};
</script>
